import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

import { AccessOperationsPage } from "./-components/access-operations-page";

const searchSchema = z.object({
  view: z.literal("user-detail").optional(),
  query: z.string().trim().max(256).optional(),
  type: z
    .enum([
      "email",
      "user_id",
      "order_id",
      "order_short_id",
      "paddle_transaction_id",
      "payment_event_id",
      "abnormal_event_id",
    ])
    .optional(),
});

export const Route = createFileRoute("/operator/access")({
  component: AccessOperationsRoute,
  validateSearch: zodValidator(searchSchema),
});

function AccessOperationsRoute() {
  const { access } = Route.useRouteContext();
  const search = Route.useSearch();

  return (
    <AccessOperationsPage
      permissions={access.permissions}
      initialLookup={search.query ? { value: search.query, type: search.type ?? "email" } : undefined}
    />
  );
}
